import { BadgeCheckIcon, ChipIcon } from "@heroicons/react/solid";
import React from "react";
import { skills, workexperience } from "../data";
import { Grid, Collapse, Typography } from '@material-ui/core'
import { makeStyles } from "@material-ui/styles";
import { generalFormStyles } from './StyleObjects/generalStyles';
import { SkillCard } from './SkillCard';


const useFormStyles = makeStyles(generalFormStyles);

export function WorkExperience() {
    const classes = useFormStyles();
    return (
        <Grid className={`${classes.experience}`}>
            <h1>PROFESSIONAL EXPERIENCE</h1>
            {workexperience.map((exp, index) => {
                return (<>
                <h2>{exp.company}</h2>
                <p>{exp.jobTitle}</p>
                <p>{exp.location}</p>
                    <p>{exp.duration}</p>
                    <a href={exp.websiteLink}>{exp.websiteLink}</a>
                    </>
                );
            })}
        </Grid>
    );
}